<template>
  <img
    v-bind:class="isActive ? 'splash-screen__img-active' : 'splash-screen__img-inactive'"
    :src="imgUrl"
    @click="onClick"/>
</template>

<script>
export default {
  name: 'SplashScreen',
  props: {
    imgUrl: String,
    isActive: Boolean,
    onClick: Function
  }
}
</script>

<style scoped>
  .splash-screen__img-active {
    cursor: pointer;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }
  .splash-screen__img-inactive {
    display: none;
  }
</style>
